import React, { PropsWithChildren } from "react";
import cadReducer from "./CADStateReducer";
import { CADActions } from "./CADActions";
import { ICADModel, ICADOperationLibraryItem, ICADOperationEditor, ICADLayer } from "../interfaces";

import { Dictionary } from "lodash";
import { AddEdgeAdjustmentStateEnum, EdgeAdjustmentWithoutID } from "../Components/EdgeTools/AddEdgeAdjustment";

export interface ICADState {
    model: ICADModel | null;
    unitSetID: number;
    hoveredOperationID: number | null;
    selectedOperationID: number | null;
    operationLibraries: Dictionary<string, ICADOperationLibraryItem[]>;
    operationEditor: ICADOperationEditor | null;
    operationEditorLoading: boolean;
    activeEdgeAdjustment: EdgeAdjustmentWithoutID | null;
    edgeToolState: AddEdgeAdjustmentStateEnum;
    currentTab:string;
    currentLayer: ICADLayer | null;
}

const DEFAULT_STATE: ICADState = {
    model: null,
    hoveredOperationID: null,
    selectedOperationID: null,
    unitSetID: 1,
    operationLibraries: {},
    operationEditor: null,
    operationEditorLoading: false,
    activeEdgeAdjustment: null,
    edgeToolState: AddEdgeAdjustmentStateEnum.None,
    currentTab:"",
    currentLayer: null,
}

const CADStateContext = React.createContext<ICADState>(DEFAULT_STATE);
const CADActionContext = React.createContext<CADActions>(null!);

export const CADContextProvider: React.FC<PropsWithChildren<any>> = ({ children }) => {

    const [state, dispatch] = React.useReducer(cadReducer, DEFAULT_STATE);

    const actions = React.useMemo<CADActions>(() => {
        return new CADActions(dispatch);
    }, [dispatch]);

    return (
        <CADStateContext.Provider value={state}>
            <CADActionContext.Provider value={actions}>
                {children}
            </CADActionContext.Provider>
        </CADStateContext.Provider>
    );
}

export function useCADState() {
    return React.useContext(CADStateContext);
}

export function useCADActions() {
    return React.useContext(CADActionContext);
}